import script from "./messageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./messageBox.vue?vue&type=script&setup=true&lang=js"

import "./messageBox.vue?vue&type=style&index=0&id=092224e8&lang=scss"

const __exports__ = script;

export default __exports__